export default "__VITE_ASSET__BJCOJvws__"